import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(userId: string, requestBody: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/User/${userId}/ConfirmEmail`;
	return axios.post(url, requestBody);
}

export interface Request {
	confirmationCode: string;
	password: string;
}
